import React from "react"
import { useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useState } from "react"
import SureModal from "src/components/Modals/SureModal"
import AdminTable from "src/pages/Administrator/Helpers/AdminTable"
import { activatorUser, getUsers } from "src/store/Slices/AuthSlice"
import TableTitle from "../Helpers/TableTitle"
import AddEditUsersModal from "./Modals/AddEditUsersModal"
import { Switch } from "antd"
import { passwrordDecoder } from "src/store/Slices/HelperSlice"
import { openNotification } from "src/components/helpers/notification"
import DeleteUserModal from "./Modals/DeleteUserModal"
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable"
import ChangePasswordModal from "./Modals/ChangePasswordModal"

const Users = ({ mnemo }) => {
  const dispatch = useDispatch()
  const searchInput = useRef(null)

  // STATE
  const [isDeleted, setIsDeleted] = useState(false)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [userInfo, setUserInfo] = useState()
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
    open: false,
    flag: "",
  })
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
const [isChangePasswordModal, setIsChangePasswordModal] = useState(false)

  const items = [
    {
      key: "1",
      label: "Редактировать",
      onClick: () => {
        setIsOpenAddEditModal({ open: true, flag: "edit" })
      },
      disabled:
        userInfo?.id === 13 ||
        !mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
    },
    {
      key: "2",
      label: "Расшифровать пароль",
      disabled: !mnemo?.children?.find((el) => el.mnemo === "decrypt"),
      onClick: () => {
        dispatch(
          passwrordDecoder({
            value: userInfo?.password,
          })
        ).then((res) => {
          if (res.payload.data.isSuccess) {
            openNotification({
              type: "success",
              message: `Пароль пользователя : ${res.payload.data.value}`,
            })
          }
        })
      },
    },
   {
      key: "3",
      onClick: () => {
        setIsChangePasswordModal(true)
      },
      label: "Сменить пароль",
    },
    {
      key: "4",
      label: "Удалить",
      onClick: () => {
        setIsOpenDeleteModal(true)
      },
      disabled:
        userInfo?.id === 13 ||
        !mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
    },
  ]

  const filterOptionsArr = [
    { label: "Фильрация", value: 0, index: undefined },
    { label: "По номеру", value: 1, index: "id", title: "Пользователь" },
    { label: "По логину", value: 2, index: "login", title: "Логин" },
    { label: "По паролю", value: 3, index: "password", title: "Пароль" },
    { label: "По роле", value: 4, index: "roleName", title: "Роль" },
    {
      label: "По активности",
      value: 5,
      index: "isActive",
      title: "Активность",
    },
    { label: "По ФИО", value: 6, index: "fio", title: "ФИО" },
    { label: "По клубу", value: 7, index: "clubName", title: "Клуб" },
  ]

  // STORE
  const usersList = useSelector((state) => state.AuthSlice.usersList)
  const usersListLoading = useSelector(
    (state) => state.AuthSlice.usersListLoading
  )

  const rowsFormated = usersList?.data?.value?.rows.map((element) => {
    return {
      ...element,
      isActive: (
        <Switch
          disabled={
            localStorage.getItem("username") === element.login ||
            element.id === 13 ||
            !mnemo?.children?.find((el) => el.mnemo === "activate")
          }
          value={element.isActive}
          onChange={() => {
            dispatch(
              activatorUser({
                id: element.id,
                active: element.isActive ? false : true,
              })
            ).then(() => {
              dispatch(getUsers())
              setPage(1)
              setPageSize(20)
            })
          }}
        />
      ),
    }
  })

  // FUNC
  const onClickDelete = () => {
    dispatch(
      activatorUser({
        id: userInfo.id,
        active: false,
      })
    ).then(() => {
      dispatch(getUsers())
      setIsOpenDeleteModal(false)
    })
    setPage(1)
    setPageSize(20)
  }

  const searchItemsMap = (keys, values) => {
    const formattedItems = {}
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] && values[index][0]) {
          if (key === "id") {
            formattedItems["idFrom"] = values[index][0]
            formattedItems["idTo"] = values[index][1]
          } else if (key === "roleName") {
            formattedItems["RoleId"] = values[index][0]
          } else if (key === "clubName") {
            formattedItems["clubId"] = values[index][0]
          } else {
            formattedItems[key] = values[index][0]
          }
        }
      })
      return formattedItems
    }
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(Object.keys(filters), Object.values(filters))
    dispatch(
      getUsers({
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order
          ? sorter.order === "ascend"
            ? true
            : false
          : undefined,
        ...payload,
      })
    )
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  const clickOnAction = (element) => {
    setUserInfo(element)
  }

  const handlePaginationChange = (page, pageSize) => {
    dispatch(
      getUsers({
        flag: "get",
        value: {
          count: pageSize,
          offset: pageSize * (page - 1),
        },
      })
    )
    setPage(page)
    setPageSize(pageSize)
  }

  const onClickSearchItem = (selectedKeys, dataIndex) => {
    setPage(1)
    setPageSize(20)
    dispatch(
      getUsers({
        flag: "get",
        value: {
          isDeleted: isDeleted,
          [`${dataIndex}`]: selectedKeys[0],
        },
      })
    )
  }

  const handleSwitchChange = (element) => {
    dispatch(
      activatorUser({
        id: element.id,
        active: element.isActive ? false : true,
      })
    ).then(() => {
      dispatch(getUsers())
      setPage(1)
      setPageSize(20)
    })
  }

  // USEEFFECTS
  useEffect(() => {
    dispatch(getUsers())
  }, [])

  return (
    <>
    <ChangePasswordModal
            visible={isChangePasswordModal}
            setVisible={setIsChangePasswordModal}
            clientInfo={userInfo}
            onSuccess={() => {
        // Обновляем таблицу после успешной смены пароля
        dispatch(getUsers({
            count: pageSize,
            offset: pageSize * (page - 1),
        }))
    }}
            //addEditPayload={addEditPayload}
          /> 
      <AddEditUsersModal
        visible={isOpenAddEditModal}
        setVisible={setIsOpenAddEditModal}
        userInfo={userInfo}
        setPage={setPage}
        setPageSize={setPageSize}
      />
      <DeleteUserModal
        visible={isOpenDeleteModal}
        setVisible={setIsOpenDeleteModal}
        onClickDelete={onClickDelete}
        userInfo={userInfo}
      ></DeleteUserModal>
      {window.innerWidth >= 768 ? (
        <AdminTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={usersListLoading}
          onClickRowOne={(record) => {
            setUserInfo(record)
          }}
          columns={usersList}
          rows={rowsFormated}
          total={usersList?.data?.value?.totalCount}
          title={() => (
            <TableTitle
              onClickOpenModal={() => {
                setIsOpenAddEditModal({
                  open: true,
                  flag: "add",
                })
              }}
              mnemoButton={
                !mnemo?.children?.find((el) => el.mnemo === "insertBtn")
              }
            />
          )}
          items={items}
        />
      ) : (
        <AntdMobileTable
          page={page}
          setPage={setPage}
          setPageSize={setPageSize}
          elementsList={usersList}
          elementsListLoading={usersListLoading}
          setIsOpenAddEditModal={setIsOpenAddEditModal}
          setIsOpenDeleteModal={setIsOpenDeleteModal}
          handlePaginationChange={handlePaginationChange}
          onChange={handleTableChange}
          clickOnAction={clickOnAction}
          items={items}
          filterOptionsArr={filterOptionsArr}
          mnemo={mnemo}
          handleSwitchChange={handleSwitchChange}
          searchInput={searchInput}
          onClickSearchItem={onClickSearchItem}
        />
      )}
    </>
  )
}

export default Users
